import { render, staticRenderFns } from "./logistics-management.vue?vue&type=template&id=1873e09e&scoped=true&"
import script from "./logistics-management.vue?vue&type=script&lang=js&"
export * from "./logistics-management.vue?vue&type=script&lang=js&"
import style0 from "./logistics-management.vue?vue&type=style&index=0&id=1873e09e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873e09e",
  null
  
)

export default component.exports